export default {
  sections: {
    asap_orders: {
      title: 'Commandes immédiates',
      fields: {
        has_live_orders: {
          label: 'Commandes en direct',
          tooltip: "N'activez ce bouton que lorsque le restaurant est prêt à accepter des commandes",
        },
        has_asap_orders: {
          label: 'Autorisez-vous vos clients à passer des commandes immédiates ?',
          tooltip: '*Les commandes immédiates sont basées sur votre temps de préparation',
        },
      },
    },
    scheduled_orders: {
      title: 'Commandes planifiées',
      fields: {
        has_scheduled_orders: {
          label: "Autorisez-vous vos clients à commander à l'avance pour des horaires précis ?",
        },
        has_pre_order: {
          label: "Autorisez-vous vos clients à commander plus d'un jour à l'avance ?",
        },
        max_pre_order_days: {
          label: "Nombre maximum de jours à l'avance",
          placeholder: '14',
        },
        has_scheduled_order_reminders: {
          label: 'Notifications de rappel de commandes planifiées',
        },
        scheduled_orders_time_slot_interval: {
          label: 'Créneaux horaires en minutes',
          option: 'Créneau de {{value}} minutes',
        },
        has_scheduled_orders_time_slot_order_limit: {
          label: 'Ajouter une quantité maximale de commandes par créneau',
        },
        scheduled_orders_time_slot_order_limit: {
          label: 'Quantité maximale de commandes par créneau',
          placeholder: '5',
        },
        scheduled_order_option_title: {
          label: "Titre de l'option Commander pour plus tard",
          placeholder: 'Commander pour plus tard',
        },
      },
    },
    other: {
      title: 'Autre',
      fields: {
        order_approval_time_step: {
          label: 'Augmenter / réduire le temps de commande confirmé',
          option: '{{value}} min',
        },
        order_confirmation_time_extra_minutes: {
          label: 'Ajouter des minutes supplémentaires au temps confirmé',
          option: '{{value}} min',
        },
      },
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  feedback: {
    restaurant_suspended: {
      title: 'Ce restaurant a été suspendu',
      description:
        "Pour repasser en ligne, accédez à la <a>page d'abonnement</a> et réactivez le restaurant, puis vous pourrez activer les commandes en direct sur cette page.",
    },
  },
  toasts: {
    at_least_one_order_method_required:
      'Au moins 1 méthode de commande (planifiée ou immédiate) doit être activée. Vous ne pouvez pas désactiver les deux.',
  },
};
